var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.412,
    height: 26.872,
    viewBox: "0 0 20.412 26.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25803",
    "data-name": "Group 25803",
    transform: "translate(-4.529 -1.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 4.614,
    cy: 4.614,
    r: 4.614,
    transform: "translate(10.246 6.172)",
    fill: "#ffb299"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25802",
    "data-name": "Group 25802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37365",
    "data-name": "Path 37365",
    d: "M14.736,28.272a.622.622,0,0,1-.563-.359,34.577,34.577,0,0,0-5.31-7.833c-.68-.814-1.331-1.593-1.906-2.369a10.08,10.08,0,0,1-2.425-6.805c0-5.245,4.577-9.506,10.2-9.506s10.2,4.261,10.2,9.5a10.07,10.07,0,0,1-2.412,6.8c-.592.8-1.241,1.572-1.927,2.394a34.443,34.443,0,0,0-5.3,7.817.632.632,0,0,1-.306.308A.6.6,0,0,1,14.736,28.272Zm0-25.631c-4.942,0-8.961,3.7-8.961,8.257a8.848,8.848,0,0,0,2.2,6.1c.538.733,1.178,1.5,1.853,2.305a39.668,39.668,0,0,1,4.652,6.473l.26.453.259-.453a39.846,39.846,0,0,1,4.647-6.467c.706-.844,1.33-1.6,1.875-2.329A8.846,8.846,0,0,0,23.7,10.89C23.7,6.345,19.675,2.641,14.734,2.641Zm0,13.224a5.248,5.248,0,1,1,5.249-5.248A5.254,5.254,0,0,1,14.734,15.865Zm0-9.257a4.008,4.008,0,1,0,4.008,4.009A4.013,4.013,0,0,0,14.734,6.608Z",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddress);
export default __webpack_public_path__ + "static/media/icon-address.8d1eb249d8656b6965655dfee1d8f8a8.svg";
export { ForwardRef as ReactComponent };